class InterceptorConfig {

  private additionalErrors: number[] = []
  private additionalInterceptorsErrors = new Map<number, InterceptorFn>()

  addAdditionalStatusCodeError(...statusCode: number[]) {
    statusCode.forEach(code => {
      this.additionalErrors.push(code)
    })
  }

  hasAdditionalStatusCodeError(statusCode: number) {
    return this.additionalErrors.includes(statusCode)
  }

  addInterceptorStatusCodeError(statusCode: number, fn: InterceptorFn) {
    this.additionalInterceptorsErrors.set(statusCode, fn)
  }

  getInterceptorStatusCodeError(statusCode: number) {
    return this.additionalInterceptorsErrors.get(statusCode)
  }

}

export const interceptorConfig = new InterceptorConfig();

type InterceptorFn = (url: string, status: number, data: any, headers: any, response: any, next: () => {}) => {}
